import { render, staticRenderFns } from "./RegisteredBarcode.vue?vue&type=template&id=4fb92a52"
import script from "./RegisteredBarcode.vue?vue&type=script&lang=js"
export * from "./RegisteredBarcode.vue?vue&type=script&lang=js"
import style0 from "./RegisteredBarcode.vue?vue&type=style&index=0&id=4fb92a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports